var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert--card"},[_c('v-icon',{staticClass:"alert--icon"},[_vm._v(_vm._s(_vm.icon))]),_c('h3',{staticClass:"alert--text"},[_vm._v(_vm._s(_vm.text))]),_c('h3',{staticClass:"alert--text"},[_vm._v(_vm._s(_vm.subtext))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }